var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrophyLine = function SvgTrophyLine(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3347_7666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.833 14.115V15.8333H14.9997V17.5H4.99967V15.8333H9.16634V14.115C7.55526 13.9118 6.07369 13.1277 4.99968 11.9098C3.92566 10.6919 3.33304 9.12384 3.33301 7.5V2.5H16.6663V7.5C16.6663 9.12384 16.0737 10.6919 14.9997 11.9098C13.9257 13.1277 12.4441 13.9118 10.833 14.115ZM4.99967 4.16667V7.5C4.99967 8.82608 5.52646 10.0979 6.46414 11.0355C7.40182 11.9732 8.67359 12.5 9.99967 12.5C11.3258 12.5 12.5975 11.9732 13.5352 11.0355C14.4729 10.0979 14.9997 8.82608 14.9997 7.5V4.16667H4.99967ZM0.833008 4.16667H2.49967V7.5H0.833008V4.16667ZM17.4997 4.16667H19.1663V7.5H17.4997V4.16667Z",
    fill: "#EE5A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3347_7666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrophyLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "trophy-line.2052510c5d21fa6d68856897c3148a51.svg";